import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalendarDataService {
  private apiUrl = environment.ntIntegrationApiUrl;
  private calendarGatewayUrl = environment.calendarGatewayUrl;
  private calendarClientId = environment.calendarClientId;

  constructor(private http: HttpClient) {}

  getUserCalendars(corpId: string, userId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/tenant/${corpId}/user/${userId}/calendars`);
  }

  createAccessToken(code: string): Observable<{tokenId: string}> {
    return this.http.get<{tokenId: string}>(`${this.calendarGatewayUrl}/callback/${this.calendarClientId}?code=${code}&state=${this.calendarClientId}`);
  }

  setupCalendar(corpId: string, email: string, userId: string, platform: string, emailCalendarId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/calendar/setup/user`, {
      corpId,
      email,
      userId,
      platform,
      emailCalendarId
    });
  }

  deleteUserCalendar(calendarId: string, userId: string, tenantId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/signout`, {
      calendarId,
      userId,
      tenantId
    });
  }
}
